import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-not-found-error',
  imports: [ButtonModule, RouterModule],
  templateUrl: './not-found-error.component.html',
  styleUrl: './not-found-error.component.scss'
})
export class NotFoundErrorComponent implements OnInit {

  private readonly router = inject(Router);
  errorImage = 'errors/404.png'


  ngOnInit(): void {
    // this.getTheme();
  }

  goBackHome() {

    const url = this.router.url;

    const match = url.match(
      /^\/(auction|ticket-event|guests-form|items-donation|become-sponsor|contact-us|donation)\/(\d+)/
    );

    if (match) {
      const auctionId = match[2];
      this.router.navigate(['/auction', auctionId]);
      return;
    }

    this.router.navigate(['/']);

  }
}
